<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-hotel-room"
      :add-btn="false"
      :hide-action="!editable"
      hide-show-detail
      hide-edit
      hide-delete
      :modal-width="480"
      :modal-form="modalForm"
      :query="query"
      :action="action"
      :columns="columns"
      :search-key-type="{type: 1}">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.type" placeholder="输入房型查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:action="{item}">
        <div class="txt-btn" @click="assignPerson(item)">分配人员</div>
      </template>
    </data-list>
    <a-modal
      title="分配人员"
      :maskClosable="false"
      :footer="null"
      :width="600"
      @ok="visible=false"
      v-model="visible">
      <div class="meal-assign" v-if="room">
        <div class="other-title">住宿规格</div>
        <detail-view :list="room.detailList" full class="meal-info"></detail-view>
        <div class="flex-box align-center" style="margin-bottom: 10px">
          <div class="other-title" style="margin-bottom: 0">已分配嘉宾/随行人员</div>
          <person-picker
            multiple
            select-disable
            url="/activity/activity-guest"
            title="选择嘉宾/随行人员"
            :value="room.hotelAllocation ? room.hotelAllocation.map(p => p.guest) : []"
            :query="`&filter[activity_id]=${activity.id}`"
            @change="handleSelect">
            <a-button type="primary" style="margin-left: 10px"><a-icon type="plus-circle" />添加嘉宾/随行人员</a-button>
          </person-picker>
        </div>
        <div class="assign-person-list" v-if="room.hotelAllocation && room.hotelAllocation.length > 0">
          <div class="assign-person-item" v-for="(person, i) in room.hotelAllocation" :key="person.id">
            <div class="assign-person-info">
              <a-icon class="assign-person-icon" type="user" />
              <div class="assign-person-name">{{person.guest ? person.guest.name : '未知'}}</div>
              <a-icon type="close" class="assign-person-operate" @click="removePersonAssign(i)"/>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
    import DetailView from "../../../components/detail-view";
    import personPicker from "../../../components/form/person-picker";
    import {roomColumns} from "../../../common/activity/stay";
    import mixins from "../mixins";

    export default {
        name: "StayAssign",
        components: {
            personPicker,
            DetailView
        },
        mixins: [mixins],
        data() {
            return {
                columns: roomColumns,
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                room: null,
                moduleKey: 'stay-assign',
                visible: false
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=hotel,hotelAllocation';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            },
        },
        methods: {
            removePersonAssign(i) {
                const list = this.room.hotelAllocation;
                const item = list[i];
                this.$confirm({
                    title: "提示",
                    content: `确定将${item.guest ? item.guest.name : '此人'}从该住宿分配中移除吗？`,
                    onOk: () => {
                        let url = `/activity/activity-hotel-allocation/${item.id}`;
                        this.$axios({
                            url,
                            method: "DELETE",
                        }).then(() => {
                            this.$message.success("已移除");
                            list.splice(i, 1);
                        });
                    },
                    onCancel: () => {},
                });
            },
            handleSelect(list) {
                if(list && list.length > 0) {
                    const url = '/activity/activity-hotel-allocation/add-guest';
                    const room = this.room;
                    this.$axios({
                        url,
                        method: 'POST',
                        data: {
                            activity_id: room.activity_id,
                            room_id: room.id,
                            guest_id: list.map(s => s.id).join(",")
                        }
                    }).then(res => {
                        if(res.error == 0) {
                            this.getRoomAssign();
                            this.$message.success("已添加");
                        } else {
                            this.$message.warning(res.msg || '添加失败');
                        }
                    })
                }
            },
            getRoomAssign() {
                const room = this.room;
                if(room) {
                    const url = `/activity/activity-hotel-allocation?pageSize=1000&expand=guest&filter[room_id]=${room.id}`;
                    this.$axios(url).then(res => {
                        const list = res.data;
                        this.$set(room, 'hotelAllocation', list);
                    });
                }
            },
            assignPerson(record) {
                record.detailList = [
                    {label: '酒店名称', value: record.hotel ? record.hotel.name : '--'},
                    {label: '酒店地址', value: record.hotel ? record.hotel.location : '--'},
                    {label: '房型', value: record.type},
                    {label: '入住人数', value: `${record.hotelAllocation ? record.hotelAllocation.length : 0}/${record.count * record.need_num}`},
                ]
                this.room = record;
                this.getRoomAssign();
                this.visible = true;
            },
        }
    }
</script>

<style scoped lang="less">
</style>
